import { gql } from 'apollo-boost';

export const GENERATE_URL_PDF = gql`
    mutation($data: GenerateUrlPdfInput!) {
        generateUrlPdf(data: $data) {
            url
            name
            displayName
            type
            format
            size
            mime
        }
    }
`;
